import React from 'react'
import PropTypes from 'prop-types'
import styles from './Metric.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

export const Metric = ({ label, value, delta, direction, baseline, className, ...rest }) => {
  if (process.env.NODE_ENV !== 'production' && delta != null && !baseline) {
    throw new Error('Metric: a `delta` requires a `baseline` — every delta states what it is measured against.')
  }
  return (
    <div className={cx(styles.metric, className)} {...rest}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
      {delta != null && (
        <span className={styles.delta}>
          <span className={direction === 'down' ? styles.down : styles.up}>
            {direction === 'down' ? '↓' : '↑'} {delta}
          </span>
          <span className={styles.baseline}>{baseline}</span>
        </span>
      )}
    </div>
  )
}

Metric.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  delta: PropTypes.node,
  direction: PropTypes.oneOf(['up', 'down']),

  baseline: PropTypes.node,
  className: PropTypes.string,
}

export const Meter = ({ label, value, max = 100, className, ...rest }) => {
  const pct = Math.max(0, Math.min(100, (value / max) * 100))
  return (
    <div className={cx(styles.meter, className)} {...rest}>
      <div className={styles.meterHead}>
        <span>{label}</span>
        <span className={styles.meterValue}>{value}/{max}</span>
      </div>
      <div
        className={styles.track}
        role="progressbar"
        aria-label={typeof label === 'string' ? label : undefined}
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
      >
        <div className={styles.fill} style={{ width: `${pct}%` }} />
      </div>
    </div>
  )
}

Meter.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  max: PropTypes.number,
  className: PropTypes.string,
}

export default Metric
